export function isValidNumericValue(val: unknown) {
  return typeof val === 'number' && !Number.isNaN(val) && Number.isFinite(val);
}
